// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header>
  <button class="btn btn-primary"
          command-access="CreateRiskProfile"
          ng-disabled="\$ctrl.disableCalculate"
          ng-click="\$ctrl.calculate()">
    Calculate new risk profile
  </button>
</customer-profile-header>
<section id="customer-risk-profile" class="box">
  <table class="table table-style table-hover risk-profile-entry__table">
    <thead>
    <th class="no-column-header">No.</th>
    <th>Risk category</th>
    <th>Subcategory</th>
    <th>Risk assessment</th>
    <th>Risk weight</th>
    <th>Risk %</th>
    <th>Risk weight score</th>
    <th>Auto-high risk</th>
    </thead>

    <tbody>
    <tr ng-repeat="entry in \$ctrl.riskProfileEntries">
      <td>{{\$index + 1}}.</td>
      <td class="category-name">{{entry.category.name}}</td>
      <td class="category-name">{{entry.categoryEntry.description || '-'}}</td>
      <td ng-if="entry.riskDictionaryEntryId">
        <select ng-model="entry.riskDictionaryEntryId"
                disabled="disabled"
                ng-options="entry.id as entry.code for entry in \$ctrl.customerRiskLevels">
        </select>
      </td>
      <td ng-if="!entry.riskDictionaryEntryId">
        -
      </td>
      <td>{{ entry.weight || '-'}}</td>
      <td>{{ entry.categoryWeightPercentage}}</td>
      <td>{{ entry.riskCategoryId ? entry.score : '-'}}</td>
      <td>{{ entry.riskCategoryId ? entry.autoHighRisk : '-' }}</td>
    </tr>
    </tbody>
  </table>

  <form name="\$ctrl.form">
    <div class="form-section">
      <form-section form-title="'Summary:'">
        <form-section-field field-title="'Score:'">
          <input type="number"
                 ng-model="\$ctrl.riskProfile.score"
                 disabled="disabled"/>
        </form-section-field>
        <form-section-field field-title="">
          <input type="checkbox"
                 disabled="disabled"
                 ng-model="\$ctrl.riskProfile.autoHighRisk"/>
          <span class="form-section-field-title right-field-title">Auto-high risk</span>
        </form-section-field>
        <form-section-field field-title="'Risk level:'">
          <div class="flex-container">
            <select ng-model="\$ctrl.riskProfile.riskDictionaryEntryId"
                    disabled="disabled"
                    ng-options="entry.id as entry.description for entry in \$ctrl.customerRiskLevels">
            </select>
            <button class="btn btn-warning watchlist-button"
                    command-access="OverrideRiskProfile"
                    ng-click="\$ctrl.override()">
              Override
            </button>
          </div>
        </form-section-field>
        <form-section-field field-title="'Previous risk level:'">
          <select ng-model="\$ctrl.riskProfile.previousRiskDictionaryEntryId"
                  disabled="disabled"
                  ng-options="entry.id as entry.code for entry in \$ctrl.customerRiskLevels">
          </select>
        </form-section-field>
        <form-section-field field-title="'Remarks:'">
          <input
            type="text"
            ng-model="\$ctrl.riskProfile.remarks"
            ng-minlength="1"
            ng-maxlength="256"/>
        </form-section-field>
        <form-section-field field-title="'Override remarks:'" ng-if="\$ctrl.riskProfile.overridden">
          <input
            type="text"
            disabled="disabled"
            ng-model="\$ctrl.riskProfile.overrideRemarks"
            ng-minlength="1"
            ng-maxlength="256"/>
        </form-section-field>
      </form-section>
    </div>
  </form>

  <div class="clearfix"></div>

  <div class="buttons">
    <button class="btn btn-warning"
            ng-click="\$ctrl.goBack()">
      Cancel
    </button>
    <button class="btn btn-primary"
            command-access="UpdateRiskProfile"
            ng-disabled="!\$ctrl.riskProfile"
            ng-click="\$ctrl.save()">
      Save
    </button>
    <button type="button" class="btn btn-success"
            ng-disabled="!\$ctrl.enablePrinting"
            ng-click="\$ctrl.printCustomerRiskProfile()">
      Print
    </button>
  </div>

  <div class="clearfix"></div>

  <table class="table table--small">
    <thead>
    <th>Risk level</th>
    <th>Total risk weight base</th>
    </thead>

    <tbody>
    <tr ng-repeat="ra in \$ctrl.riskAssessments">
      <td>
        {{\$ctrl.getRiskLevelName(ra)}}
      </td>
      <td>
        {{ra.minPoints + '-' + ra.maxPoints + ' points' }}
      </td>
    </tr>
    </tbody>
  </table>
</section>

<modal on-api-ready="\$ctrl.onModalApiReady" form="\$ctrl.modalForm">
  <modal-header>
    <h3>Override risk level</h3>
  </modal-header>
  <modal-body>
    <ng-form name="\$ctrl.modalForm">
      <form-section>
        <form-section-field field-title="'Risk level:'">
          <select required
                  ng-model="\$ctrl.overrideRiskDictionaryEntryId"
                  ng-options="entry.id as entry.description for entry in \$ctrl.customerRiskLevels">
          </select>
        </form-section-field>
        <form-section-field field-title="'Override remarks:'">
          <input
            type="text"
            required
            ng-model="\$ctrl.overrideRemarks"
            ng-minlength="1"
            ng-maxlength="256"/>
        </form-section-field>
      </form-section>
    </ng-form>
  </modal-body>
</modal>

<modal on-api-ready="\$ctrl.onSubcategoryModalApiReady">
  <modal-header>
    <h3>Select subcategories to include in Risk Profile computation</h3>
  </modal-header>
  <modal-body>
    <form name="\$ctrl.form" style="min-height: 400px;">
      <table class="table table-style table-hover risk-profile-entry__table">
        <thead>
          <th class="no-column-header">No.</th>
          <th>Risk category</th>
          <th>Subcategory</th>
        </thead>
        <tbody>
          <tr ng-repeat="category in \$ctrl.riskCategoriesForManualSelection">
            <td>{{\$index + 1}}.</td>
            <td class="category-name">{{category.name}}</td>
            <td ng-if="category.assignTo === 'LINKED_CONDITIONS'">
              <select ng-disabled="true"></select>
            </td>
            <td ng-if="category.assignTo !== 'LINKED_CONDITIONS' && category.selectorType === 'SINGLE_SELECT'">
              <select ng-model="category.selectedSubcategoryIds"
                      ng-options="entry.id as entry.description for entry in category.valuesForSelection">
              </select>
            </td>
            <td ng-if="category.assignTo !== 'LINKED_CONDITIONS' && category.selectorType === 'MULTI_SELECT'">
              <multiselect items="category.valuesForSelection"
                           label-property="'description'"
                           value-property="'description'"
                           ng-model="category.selectedSubcategoryIds">
              </multiselect>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </modal-body>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/profile/risk/customer-risk-profile.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;